
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/[[...location]]",
      function () {
        return require("private-next-pages/shops/[[...location]]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops/[[...location]]"])
      });
    }
  